import { Directive, ElementRef, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
declare var google: any;

@Directive({
    selector: '[old-google-picker]'
})
export class GooglePlaceDirective implements OnInit, OnChanges {
    @Input() radius: any;

    @Output() onSelect: EventEmitter<any> = new EventEmitter();
    private element: HTMLInputElement;
    constructor(elRef: ElementRef, private mapsAPILoader: MapsAPILoader) {
        this.element = elRef.nativeElement;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.radius && changes.radius.currentValue) {
            const options = this.setupOptions(changes.radius.currentValue);
            this.initAutocomplete(options);
        } else {
            this.initAutocomplete();
        }
    }

    setupOptions(radius) {
        const center = radius.center;
        if (!center) return {};
        const val = (radius.miles * 1.609344) / 100

        const defaultBounds = {
            north: center.lat + val,
            south: center.lat - val,
            east: center.lng + val,
            west: center.lng - val,
        };

        const options = {
            bounds: defaultBounds,
            strictBounds: true
        }
        return options;
    }

    ngOnInit() {
        if (this.radius) {
            const options = this.setupOptions(this.radius);
            this.initAutocomplete(options);
        } else {
            this.initAutocomplete();
        }
    }

    initAutocomplete(options?) {
        this.mapsAPILoader.load().then(() => {
            const autocomplete = new google.maps.places.Autocomplete(this.element, options ? options : {
            });

            google.maps.event.addListener(autocomplete, 'place_changed', () => {
                this.onSelect.emit(autocomplete.getPlace());
            });
        });
    }

}
